// 本番環境用設定

const IS_PC = false;

// const localAPI = 'https://uronote.ishidamedical.com/server';
// const loginUrl = 'https://uronote.ishidamedical.com/server/oauth/token'

// mod_rewrite無し版
const localAPI = 'https://uronote.ishidamedical.com/server/index.php';
const loginUrl = 'https://uronote.ishidamedical.com/server/index.php/oauth/token'

// baseURLはおそらく使用されていない。
const baseURL = 'https://area.bousai-dataeye.jp';

//  Password Grant ClientのIDとCLIENT_SECRET. Laravelで.envに指定したものと同じ
// 2025/12/13時点の本番情報
const CLIENT_ID ='1'
const CLIENT_SECRET ='RQaiz6rhkDMbBf9RuUeAZdpmjICSprDkboRmVpD3'

const GOOGLE_ANALYTICS_ID = '';

export default {
  IS_PC,
  localAPI,
  baseURL,
  GOOGLE_ANALYTICS_ID,
  loginUrl,
  CLIENT_ID,
  CLIENT_SECRET
};
